import { alpha, Button, Menu, MenuItem, MenuProps, styled } from "@mui/material"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ReactNode, useState } from "react";
import { SolveAdjudicationCaseAttack } from "neurotec-megamatcherid-management-client-adjudicator";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
    }}
    transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
    }}
    {...props}
  />))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
            fontSize: 18,
            color: theme.palette.text.secondary,
            marginRight: theme.spacing(1.5),
            ...theme.applyStyles('dark', {
                color: 'inherit',
            }),
            },
            '&:active': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                theme.palette.action.selectedOpacity,
            ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

interface IAdjudicationRejectButtonProps {
    disabled?: boolean
    solve: (attack: SolveAdjudicationCaseAttack) => void
    children?: ReactNode
}

const AdjudicationRejectButton: React.FC<IAdjudicationRejectButtonProps> = (props) => {

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSolve = (attack: SolveAdjudicationCaseAttack) => {
        setAnchorEl(null);
        props.solve(attack)
    }

    return (
        <>
        <Button
            disabled={props.disabled}
            id={"adjudication-reject-button"}
            aria-controls={open ? 'demo-customized-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            variant="contained"
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon/>}
            disableRipple
            color="error"
        >
            {props.children}
        </Button>
        <StyledMenu
            slotProps={{
                list: {
                    'aria-labelledby': 'adjudication-reject-button',
                },
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            <MenuItem onClick={() => handleSolve(SolveAdjudicationCaseAttack.AttackPicture)} disableRipple>
                Picture
            </MenuItem>
            <MenuItem onClick={() => handleSolve(SolveAdjudicationCaseAttack.AttackPaperMask)} disableRipple>
                Paper mask
            </MenuItem>
            <MenuItem onClick={() => handleSolve(SolveAdjudicationCaseAttack.AttackSiliconeMask)} disableRipple>
                Silicone mask
            </MenuItem>
            <MenuItem onClick={() => handleSolve(SolveAdjudicationCaseAttack.AttackScreenPhone)} disableRipple>
                Screen phone
            </MenuItem>
            <MenuItem onClick={() => handleSolve(SolveAdjudicationCaseAttack.AttackScreenPc)} disableRipple>
                Screen PC
            </MenuItem>
        </StyledMenu>
        </>
    )
}

export default AdjudicationRejectButton